import { Avatar, Box, Button, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Warranty } from '../../app/models/warranty';
import InfoIcon from '@mui/icons-material/Info';
import ComputerIcon from '@mui/icons-material/Computer';
import CheckIcon from '@mui/icons-material/Check';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

interface Props {
    warrantyDetailHandler: () => void;
    warrantyData: Warranty | null;
}

const WarrantyDetail = ({ warrantyDetailHandler, warrantyData }: Props) => {

    let history = useNavigate();

    return (
        <Box>
            <>
                {/* {(warrantyData?.errorMessage !== null) ?
                    <Typography sx={textStyle}>
                        Error   {warrantyData?.errorMessage}
                    </Typography>
                    : */}
                    <Box sx={{ mt: 2 }}>
                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                            <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                    <Avatar>
                                        <InfoIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary="Warranty Info:"
                                    secondary={
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                            {warrantyData?.warrantyInfo}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                            <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                    <Avatar>
                                        <ComputerIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary="Serial Number:"
                                    secondary={
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                            {warrantyData?.serialNo}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                            <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                    <Avatar>
                                        <CheckIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary="Product Info:"
                                    secondary={
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                            {warrantyData?.product}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                            <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                    <Avatar>
                                        <CalendarMonthIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary="Expiry:"
                                    secondary={
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                            {warrantyData?.expiry}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                        </List>
                        {/* <Typography sx={textStyle}>
                            Warranty Info:  {warrantyData?.warrantyInfo}
                        </Typography>
                        <Typography sx={textStyle}>
                            Serial Number: {warrantyData?.serialNo}<br />
                            Product: {warrantyData?.product}<br />
                            Expiry: {warrantyData?.expiry}<br />
                        </Typography> */}
                    </Box>
                {/* } */}
            </>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained" type="submit" onClick={() => history('/')}>
                    close
                </Button>
                <Button variant="contained" type="submit" onClick={warrantyDetailHandler} sx={{ ml: 2 }}>
                    Look up again
                </Button>

            </Box>

        </Box>
    )
}

export default WarrantyDetail

